<section class="cdfi-profile-page">
  @if (!isLoading && !isNotFound) {
    <button type="button" class="back-link" (click)="goBackToCdfis()">
      <app-svg-icon
        [iconName]="'previous.svg'"
        [width]="'14px'"
        [height]="'14px'"
      ></app-svg-icon>
      Back
    </button>

    <div class="profile-hero" id="tour-view-profile-details">
      <div class="profile-identity">
        <div class="avatar-wrapper">
          @if (cdfiProfileDetails.cdfi_logo) {
            <img
              [src]="getImageUrl(cdfiProfileDetails.cdfi_logo)"
              alt="CDFI logo"
              class="avatar-img"
            />
          } @else {
            <div class="avatar-initials">
              {{ (cdfiProfileDetails.name || "-").charAt(0).toUpperCase() }}
            </div>
          }
        </div>

        <div class="profile-info">
          <span class="eyebrow">Organization profile</span>
          <h1>{{ cdfiProfileDetails.name || "-" }}</h1>
          <p>{{ getDescriptionText(cdfiProfileDetails.description) }}</p>
          <div class="profile-highlights">
            <!-- <span
              >{{
                formatCurrency(cdfiProfileDetails.total_funded_amount)
              }}
              funded</span
            > -->
          </div>
        </div>
      </div>

      <div class="contact-info-compact">
        <div class="contact-item">
          <svg
            class="contact-icon"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
              fill="currentColor"
            />
          </svg>
          <span class="contact-label">Email:</span>
          @if (cdfiProfileDetails.email) {
            <a
              class="contact-link"
              [href]="'mailto:' + cdfiProfileDetails.email"
            >
              {{ cdfiProfileDetails.email }}
            </a>
          } @else {
            <span class="contact-empty">—</span>
          }
        </div>
        <div class="contact-item">
          <svg
            class="contact-icon"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z"
              fill="currentColor"
            />
          </svg>
          <span class="contact-label">Phone:</span>
          @if (cdfiProfileDetails.phone) {
            <a class="contact-link" [href]="'tel:' + cdfiProfileDetails.phone">
              {{ cdfiProfileDetails.phone }}
            </a>
          } @else {
            <span class="contact-empty">—</span>
          }
        </div>
        <div class="contact-item">
          <svg
            class="contact-icon"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 19.93C7.05 19.44 4 16.08 4 12C4 11.38 4.08 10.79 4.21 10.21L9 15V16C9 17.1 9.9 18 11 18V19.93ZM17.9 17.39C17.64 16.58 16.9 16 16 16H15V13C15 12.45 14.55 12 14 12H8V10H10C10.55 10 11 9.55 11 9V7H13C14.1 7 15 6.1 15 5V4.59C17.93 5.78 20 8.65 20 12C20 14.08 19.2 15.97 17.9 17.39Z"
              fill="currentColor"
            />
          </svg>
          <span class="contact-label">Website:</span>
          @if (cdfiProfileDetails.website) {
            <a
              class="contact-link"
              [href]="getWebsiteUrl(cdfiProfileDetails.website)"
              target="_blank"
              rel="noopener"
            >
              {{ cdfiProfileDetails.website }}
            </a>
          } @else {
            <span class="contact-empty">—</span>
          }
        </div>
      </div>
    </div>

    @if (isStitch) {
      <div class="stitch-details-container">
        <!-- Section 1: Business Loans -->
        <div class="stitch-section">
          <div class="stitch-header">
            <h2 class="stitch-title">What Business Loans are Available?</h2>
            <div class="stitch-accent-bar"></div>
            <p class="stitch-subtitle">Two products:</p>
          </div>

          <div class="stitch-table-wrapper">
            <table class="stitch-table products-table">
              <thead>
                <tr>
                  <th class="col-feature" scope="col"></th>
                  <th class="col-term-loan" scope="col">Term Loan</th>
                  <th class="col-line-of-credit" scope="col">Line of Credit</th>
                </tr>
              </thead>
              <tbody>
                @for (item of stitchLoanProducts; track item.feature) {
                  <tr>
                    <td class="cell-feature">{{ item.feature }}</td>
                    <td class="cell-value">{{ item.termLoan }}</td>
                    <td class="cell-value">{{ item.lineOfCredit }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

        <!-- Section 2: Underwriting Criteria -->
        <div class="stitch-section">
          <div class="stitch-header">
            <h2 class="stitch-title criteria-title">
              At a Glance: Underwriting Criteria
            </h2>
          </div>

          <div class="stitch-table-wrapper">
            <table class="stitch-table criteria-table">
              <thead>
                <tr>
                  <th class="col-category" scope="col">Category</th>
                  <th class="col-details" scope="col">Details</th>
                </tr>
              </thead>
              <tbody>
                @for (item of stitchUnderwritingCriteria; track item.category) {
                  <tr>
                    <td class="cell-category">{{ item.category }}</td>
                    <td class="cell-details">{{ item.details }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

        <!-- Section 3: Which Businesses Are Eligible -->
        <div class="stitch-section">
          <div class="stitch-header">
            <h2 class="stitch-title criteria-title">
              Which Businesses Are Eligible?
            </h2>
            <p class="stitch-eligibility-desc">
              Small businesses organized in the United States are generally
              eligible, subject to some exceptions:
            </p>
          </div>

          <div class="stitch-exceptions-card">
            <ul class="stitch-exceptions-list">
              @for (exception of stitchEligibilityExceptions; track exception) {
                <li>
                  <span class="exception-bullet">—</span>
                  <span class="exception-text">{{ exception }}</span>
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
    } @else {
      <div class="profile-grid">
        <div class="impact-card" id="tour-funding-activity">
          <div class="section-heading">
            <span>Funding Activity</span>
          </div>
          @if (hasFundingActivity) {
            <div class="impact-amount">
              {{ formatCurrency(cdfiProfileDetails.total_funded_amount) }}
            </div>
            <p>Total funding amount recorded in the platform</p>
          } @else {
            <div class="impact-amount no-data">No funding recorded</div>
          }
        </div>

        <div class="support-card" id="tour-products-offered">
          <div class="section-heading">
            <span>Products Offered</span>
            <strong>{{ getSupportedProductsCount() }} Products</strong>
          </div>
          <div class="tag-list">
            @for (product of getSupportedProducts(); track product) {
              <span>{{ product }}</span>
            } @empty {
              <strong>-</strong>
            }
          </div>
        </div>

        <div class="region-card" id="tour-service-area">
          <div class="section-heading">
            <span>Service Area</span>
            @if (!isOnlyNationwide() && getServiceRegionCount() > 0) {
              <button
                type="button"
                class="view-details-button"
                (click)="openRegionModal()"
              >
                View Details
              </button>
            }
          </div>
          <div class="tag-list">
            @for (count of getSupportedRegionCounts(); track count.type) {
              <span [class.clickable]="count.type !== 'nationwide'">
                {{ count.label }}
              </span>
            } @empty {
              <strong>-</strong>
            }
          </div>
        </div>
      </div>
    }

    @if (isSmeUser) {
      <div class="preparation-card">
        <div class="preparation-header">
          <div class="preparation-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
              <path
                d="M439.4 96L448 96C483.3 96 512 124.7 512 160L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 160C128 124.7 156.7 96 192 96L200.6 96C211.6 76.9 232.3 64 256 64L384 64C407.7 64 428.4 76.9 439.4 96zM376 176C389.3 176 400 165.3 400 152C400 138.7 389.3 128 376 128L264 128C250.7 128 240 138.7 240 152C240 165.3 250.7 176 264 176L376 176zM256 320C256 302.3 241.7 288 224 288C206.3 288 192 302.3 192 320C192 337.7 206.3 352 224 352C241.7 352 256 337.7 256 320zM288 320C288 333.3 298.7 344 312 344L424 344C437.3 344 448 333.3 448 320C448 306.7 437.3 296 424 296L312 296C298.7 296 288 306.7 288 320zM288 448C288 461.3 298.7 472 312 472L424 472C437.3 472 448 461.3 448 448C448 434.7 437.3 424 424 424L312 424C298.7 424 288 434.7 288 448zM224 480C241.7 480 256 465.7 256 448C256 430.3 241.7 416 224 416C206.3 416 192 430.3 192 448C192 465.7 206.3 480 224 480z"
              />
            </svg>
          </div>
          <div>
            <h3>Before You Reach Out</h3>
            <p>Ensure your business profile is ready for Organization review</p>
          </div>
          <button
            type="button"
            class="preparation-action"
            (click)="goToBusinessRecords()"
          >
            Prepare Business Profile
          </button>
        </div>
        <ul class="preparation-list">
          @for (step of preparationSteps; track step) {
            <li>
              <app-svg-icon
                [iconName]="'check-simple.svg'"
                [width]="'14px'"
                [height]="'14px'"
              ></app-svg-icon>
              <span>{{ step }}</span>
            </li>
          }
        </ul>
      </div>
    }
  }

  @if (isRegionModalOpen) {
    <app-region-details
      [isOpen]="isRegionModalOpen"
      [regions]="cdfiProfileDetails.supported_regions!"
      [defaultTab]="regionModalDefaultTab"
      (closed)="closeRegionModal()"
    ></app-region-details>
  }

  @if (isNotFound && !isLoading) {
    <div class="empty-state">
      <div class="empty-title">Organization Not Found</div>
      <div class="empty-description">
        The requested Organization profile does not exist.
      </div>
      <button type="button" class="secondary-action" (click)="goBackToCdfis()">
        Back to Organizations
      </button>
    </div>
  }
</section>
